import * as FileSaver from 'file-saver';
import {HttpResponse} from "@angular/common/http";

declare var $: any;

export class BrowserSupport {

    public static saveXlsx(response) {
        this.saveFile(response, FileType.XLSX);
    }

    public static savePDF(response) {
        this.saveFile(response, FileType.PDF);
    }

    public static saveTextFile(response) {
        this.saveFile(response, FileType.TEXT);
    }

    public static saveCsvFile(response) {
        this.saveFile(response, FileType.CSV);
    }

    private static saveFile(response: HttpResponse<any>, fallbackFileType: FileType) {
        const filename = this.getFilename(response);

        let contentType = null;
        if (response.headers.has('Content-Type')) {
            contentType = response.headers.get('Content-Type');
        } else {
            contentType = FileType.getAll().find((f) => f === fallbackFileType).contentType;
        }
        const file = new Blob([response.body], {type: contentType});
        BrowserSupport.saveAs(file, filename);
    }

    static saveAs(data, filename: string): void {
        FileSaver.saveAs(data, filename);
    }

    static getFilename(response: HttpResponse<any>) {
        let filename = null;
        const attachmentRegEx = /filename="(.*)"/;
        let attachmentMatch = null;
        if (response.headers.has('Content-Disposition')) {
            attachmentMatch = attachmentRegEx.exec(response.headers.get('Content-Disposition'));
        }
        if (attachmentMatch && attachmentMatch.length > 1 && attachmentMatch[1]) {
            filename = attachmentMatch[1];
        }
        return filename;
    }

    public static safeModal(selector: string, action: string) {
        const jqueryElement = $(selector);
        if (jqueryElement && jqueryElement.modal) {
            jqueryElement.modal(action);
        }
    }


    public static formatBytes(bytes, decimals = 2) {
        if (bytes === 0) {
            return '0 Bytes';
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals || 2;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }

}

export class FileType {

    public static get PDF() {
        return {extension: "pdf", contentType: "application/pdf"};
    }

    public static get XLS() {
        return {extension: "xls", contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"};
    }

    public static get XLSX() {
        return {extension: "xlsx", contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"};
    }

    public static get CSV() {
        return {extension: "csv", contentType: "text/csv"};
    }

    public static get TEXT() {
        return {extension: "text", contentType: "application/text"};
    }

    public static get GROOVY() {
        return {extension: "groovy", contentType: "application/text"};
    }

    public static get XML() {
        return {extension: "xml", contentType: "application/xml"};
    }

    public static getAll() {
        return [
            this.XLS,
            this.XLSX,
            this.CSV,
            this.TEXT,
            this.GROOVY,
            this.XML,
            this.PDF
        ];
    }
}

